import { useState } from 'react'
import Header from '../../components/Header'
import HeaderImage from '../../images/mission-img.jpg'
import Card from '../../UI/Card'
import { pricing } from '../../data'
import { PassPurchaseModal } from '../../components/BookingComponents'
import './pricing.css'

// Map a pricing card's price (or id, if you'd rather) to the
// passType id the PassPurchaseModal / backend understands.
// Adjust the keys here if your data.js prices differ.
const PRICE_TO_PASS_TYPE = {
  25:  'dropin',
  84:  'pass4',
  152: 'pass8',
  129: 'member2x',
  169: 'memberUnl',
}

const Pricing = () => {
  const [showPurchaseModal, setShowPurchaseModal] = useState(false)
  const [selectedPassType, setSelectedPassType] = useState('pass4')

  const openPurchaseModal = (passTypeId) => {
    setSelectedPassType(passTypeId || 'pass4')
    setShowPurchaseModal(true)
  }

  return (
    <>
      <Header title="Class Pricing" image={HeaderImage}>
        Class packages are priced to give you the best value for money. We have a variety to suit your wallet and needs. Please be aware that you will have to sign a contract for memberships.
      </Header>

      <section className='pricing'>
        <div className='container pricing__drop-in'>
          <div className='pricing__columns'>
            <div className='pricing__column'>
              <h3 className='pricing__column-title'>Group Classes</h3>
              <h1 className='pricing__column-price'>$25</h1>
              <p className='pricing__column-detail'>Single class · 1.25hr or 1.5hr</p>
            </div>

            <div className='pricing__divider' />

            <div className='pricing__column pricing__column--left'>
              <h3 className='pricing__column-title'>Private Classes</h3>
              <p className='pricing__column-detail'>One-to-one sessions with Tricia.</p>
              <p className='pricing__column-detail'>Scroll down for pricing and booking.</p>
            </div>
          </div>
        </div>

        <div className='container pricing__container'>
          {pricing.map(({ id, title, description, price, features, path }) => {
            // Resolve which passType this card represents.
            // Prefer an explicit passTypeId field on the data; fall back to price lookup.
            const passTypeId = PRICE_TO_PASS_TYPE[price] || null
            const purchasable = Boolean(passTypeId)

            return (
              <Card key={id} className="plan">
                <h3>{title}</h3>
                <small>{description}</small>
                <h1>{`$${price}`}</h1>
                <h4>Features</h4>
                {features.map(({ feature, available }, index) => (
                  <p key={index} className={!available ? 'disabled' : ''}>
                    {feature}
                  </p>
                ))}

                {purchasable ? (
                  <button
                    type="button"
                    className='btn lg'
                    onClick={() => openPurchaseModal(passTypeId)}
                  >
                    Choose
                  </button>
                ) : (
                  // Memberships / anything not yet wired to self-serve checkout
                  // keep the original link behavior so nothing is silently broken.
                  <a href={path} className='btn lg'>Choose</a>
                )}
              </Card>
            )
          })}
        </div>

        <div className='container pricing__private'>
          <h3 className='pricing__private-title'>Private Classes</h3>
          <p className='pricing__private-intro'>
            One-to-one sessions with Tricia, tailored entirely to you.
          </p>
          <table className='pricing__private-table'>
            <thead>
              <tr>
                <th>Package</th>
                <th>Duration</th>
                <th>Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 class</td>
                <td>1.5 hr</td>
                <td>$129</td>
                <td><a href='https://buy.stripe.com/dRm6oI3n50V8fqa0l5bMQ00' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>3 classes</td>
                <td>1.5 hr each</td>
                <td>$387</td>
                <td><a href='https://buy.stripe.com/4gM3cwaPx0V8di2d7RbMQ01' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>3 classes</td>
                <td>1 hr each</td>
                <td>$324</td>
                <td><a href='https://buy.stripe.com/00w00kg9eLY2DoffZbMQ03' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
              <tr>
                <td>10 classes</td>
                <td>1 hr each</td>
                <td>$880</td>
                <td><a href='https://buy.stripe.com/cNi00k2j19rE1zk6JtbMQ02' className='pricing__private-link' target='_blank' rel='noreferrer'>Pay by card</a></td>
              </tr>
            </tbody>
          </table>
          <p className='pricing__private-note'>
            Card payments include a small processing fee. To pay directly via Zelle, Venmo, or cash, contact us below.
          </p>
          <a href='mailto:info@iy-sp.com' className='btn lg pricing__private-btn'>
            Contact us to book
          </a>
        </div>
      </section>

      {showPurchaseModal && (
        <PassPurchaseModal
          onClose={() => setShowPurchaseModal(false)}
          prefillPassType={selectedPassType}
        />
      )}
    </>
  )
}

export default Pricing
